import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FooterwithoutLogin from "../../Pages Without Login/controllEnvironmentPolyhouse/footerwithoutLogin";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { enquirySchema } from "../../Schemas/Enquiry/enquiry_schema";
import { BsBoxArrowInRight } from "react-icons/bs";
import { useEffect } from "react";

const AIFSubsidy = () => {
  const { state, city } = useParams();
  const [loading, setLoading] = useState(false);
  const [district, setDistrict] = useState([]);

  const handelSubmit = (values) => {
    values = { ...values, origin: "AIF-Alpha" };
    setLoading(true);
    performRequest("POST", "/enquiryWebhook/createEnquiry/", values)
      .then((res) => {
        if (res.status === 201)
          Toast("success", "Enquiry Created Successfully!");
        else Toast("error", "Error while uploading");
      })
      .catch(CustomErrorResponse)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/subsidy/get-district/?state=${state}`)
      .then((res) => {
        if (res.status === 201) {
          const first15Districts = res.data
            .slice(0, 15)
            .map((d) => d.toLowerCase());

          setDistrict(first15Districts);
        } else {
          Toast("error", "Error while getting application!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [state]);

  if (loading) return <LoadingPage />;

  return (
    <div>
      <Helmet>
        <title>
          AIF Subsidy in {city}, {state} | Hydroponic Government Support
        </title>
        <meta
          name="description"
          content={`Learn how farmers in ${city}, ${state} can apply for the Agriculture Infrastructure Fund (AIF) subsidy. Get funding for hydroponics, polyhouses, and protected farming with low-interest loans.`}
        />
        <meta
          name="keywords"
          content={`
      AIF subsidy in ${city},
      AIF subsidy in ${state},
      AIF hydroponic subsidy ${city},
      AIF hydroponic subsidy ${state},
      Agriculture Infrastructure Fund ${city},
      Agriculture Infrastructure Fund ${state},
      AIF loan scheme ${city},
      AIF loan scheme ${state},
      AIF government subsidy hydroponics ${city},
      AIF government subsidy hydroponics ${state}
    `}
        />
        <meta
          property="og:title"
          content={`AIF Subsidy in ${city}, ${state}`}
        />
        <meta
          property="og:description"
          content={`Apply for AIF government subsidy in ${city}, ${state}. Easy loans with interest subvention and credit guarantee for hydroponics projects.`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://alpha.kryzen.com/aif-government-subsidy/${state}/${city}`}
        />
        <link
          rel="canonical"
          href={`https://alpha.kryzen.com/aif-government-subsidy/${state}/${city}`}
        />
      </Helmet>

      <div className="px-3 px-md-8 ms-md-8 me-md-8  py-4">
        <h1
          className="text-center fw-bold text-uppercase"
          style={{ fontSize: "2.2rem" }}
        >
          AIF Government Subsidy in {city}, {state}!
        </h1>
        <hr></hr>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="p-1 p-md-2">
              {/* Content Section */}
              <div className="">
                <h2 className="lh-lg fs-1 text-center">
                  The{" "}
                  <strong>Agriculture Infrastructure Fund (AIF Subsidy)</strong>{" "}
                  by <strong>Kryzen Biotech</strong> is a flagship Government of
                  India scheme designed to strengthen{" "}
                  <strong>agriculture infrastructure</strong>. It provides{" "}
                  <strong>medium to long-term financing</strong> for
                  post-harvest facilities, supply chain management, and modern
                  farming systems like hydroponics, polyhouses, and cold
                  storage. Farmers and agri-entrepreneurs in{" "}
                  <strong>{state}</strong>, including urban centers like{" "}
                  <strong>{city}</strong>, can access low-interest loans under
                  the AIF scheme to scale their agricultural projects
                  effectively.
                </h2>
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844978/1_lcn5uf.jpg"
                  alt="middle img"
                  className="w-100 my-3"
                />
                {/* <p className="fs-6 lh-lg mt-3">
                  Eligible beneficiaries can avail <strong>interest subvention of 3% per annum</strong> on loans up to ₹2 crore for 7 years. <strong>Credit guarantee coverage</strong> is available for loans up to ₹2 crore, easing collateral requirements.
                </p>

                <p className="fs-6 lh-lg">
                  Hydroponics projects in <strong>{city}</strong> benefit from reduced financial burden for NFT systems, deep-water culture, vertical farming, and protected cultivation, especially in {state}.
                </p>

                <p className="fs-6 lh-lg">
                  The scheme also supports <strong>FPOs, startups, and agri-tech companies</strong> for collaborative hydroponics projects and commercial-scale farms. Kryzen Biotech helps in project preparation, subsidy consultation, and execution.
                </p> */}
                <p className="fs-2 lh-lg mt-5">
                  {" "}
                  Under AIF, eligible beneficiaries can avail{" "}
                  <strong>interest subvention of 3% per annum</strong> on loans
                  up to ₹2 crore for a maximum period of 7 years. Additionally,{" "}
                  <strong>credit guarantee coverage</strong> is available for
                  loans up to ₹2 crore, making it easier for small and medium
                  farmers in {state} to secure financing without heavy
                  collateral requirements.{" "}
                </p>{" "}
                <p className="fs-2 lh-lg">
                  {" "}
                  For hydroponics projects in <strong>{city}</strong> and nearby
                  regions, AIF reduces the financial burden of setting up
                  nutrient film technique (NFT) systems, deep-water culture,
                  vertical farming, and protected cultivation structures. This
                  is particularly useful in {state}, where rising land prices
                  and water scarcity are pushing farmers toward
                  resource-efficient farming models.{" "}
                </p>{" "}
                <p className="fs-2 lh-lg">
                  {" "}
                  The scheme also supports{" "}
                  <strong>FPOs (Farmer Producer Organizations)</strong>,
                  startups, and agri-tech companies, making it an ideal choice
                  for collaborative hydroponics projects and commercial-scale
                  farms. Beyond financing, AIF ensures smoother supply chains,
                  better price realization, and reduced post-harvest losses for
                  farmers in {city} and across {state}.{" "}
                </p>{" "}
                <p className="fs-2 lh-lg">
                  {" "}
                  If you are planning to establish a hydroponics or protected
                  farming unit in <strong>{city}</strong>, applying for the{" "}
                  <strong>AIF scheme</strong> can drastically improve the
                  affordability and scalability of your project. Kryzen Biotech
                  provides complete assistance in project preparation, subsidy
                  consultation, and execution.{" "}
                </p>{" "}
                {/* <p className="fs-2 lh-lg">
                  {" "}
                  In conclusion, the <strong>AIF Hydroponic Subsidy</strong> is
                  a golden opportunity for farmers and agri-entrepreneurs in{" "}
                  {state}. Whether you are based in {city} or agricultural belts
                  like Nashik, Pune, and Nagpur, the AIF scheme offers{" "}
                  <strong>
                    {" "}
                    affordable financing, interest subvention, and credit
                    support{" "}
                  </strong>{" "}
                  for building future-ready farming infrastructure.{" "}
                </p> */}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 mt-4 mt-md-5 p-3 border d-flex flex-column  align-items-center">
            {/* Form Section */}
            <div>
              <Formik
                initialValues={enquiryInfo}
                validationSchema={enquirySchema}
                onSubmit={handelSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form
                    className="card p-3 p-md-5 bg-green-lt"
                    // style={{ backgroundColor: "lightgreen" }}
                  >
                    <h2
                      className="fs-2 fs-md-3 text-center mb-3"
                      style={{ color: "black" }}
                    >
                      Join an expert call for agriculture infrastructure
                      fund(AIF) government subsidy in {city}, {state}
                    </h2>
                    <hr></hr>
                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        First Name
                      </label>
                      <CustomInput name="firstName" type="text" />
                      {props.touched.firstName && props.errors.firstName && (
                        <p className="text-danger">{props.errors.firstName}</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Last Name
                      </label>
                      <CustomInput name="lastName" type="text" />
                      {props.touched.lastName && props.errors.lastName && (
                        <p className="text-danger">{props.errors.lastName}</p>
                      )}
                    </div>

                    {/* <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Full Name
                      </label>
                      <CustomInput name="fullName" type="text" />
                      {props.touched.fullName && props.errors.fullName && (
                        <p className="text-danger">{props.errors.fullName}</p>
                      )}
                    </div> */}

                    <div className="mb-3">
                      <label
                        className="form-label required"
                        style={{ color: "black" }}
                      >
                        Mobile Number
                      </label>
                      <CustomInput name="mobileNumber" type="text" />
                      {props.touched.mobileNumber &&
                        props.errors.mobileNumber && (
                          <p className="text-danger">
                            {props.errors.mobileNumber}
                          </p>
                        )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label" style={{ color: "black" }}>
                        Email
                      </label>
                      <CustomInput name="email" type="text" />
                      {props.touched.email && props.errors.email && (
                        <p className="text-danger">{props.errors.email}</p>
                      )}
                    </div>

                    <div className="text-center mt-3">
                      {/* <FormSubmitButton buttonText="Submit" /> */}
                      <button
                        class="btn btn-github  btn mx-1 mt-2 text-center"
                        isSubmitting={props.isSubmitting}
                      >
                        <BsBoxArrowInRight className="fs-2 me-2"></BsBoxArrowInRight>
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div className="mt-3">
              <img
                className="w-100"
                style={{ height: "750px" }}
                src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/sidebar_id3qyb.jpg"
                alt="conditions img"
              />
            </div>
          </div>
        </div>

        {/* Conditions Section */}
        <div className="row mt-7">
          {/* <div className="col-12 col-md-4 mt-4 mt-md-0">
            <img
              className="w-100"
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/subsidy_conditions_u2p8a1.jpg"
              alt="conditions img"
            />
          </div> */}
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/subsidy_conditions_u2p8a1.jpg"
              alt="benefits img"
            />
          </div>
          <div className="col-12 col-md-8">
            <h2 className="fw-bold text-uppercase mb-3 fs-1 mt-5 mt-md-0 mt-lg-0">
              AIF Subsidy Conditions
            </h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              Kryzen Biotech actively assists farmers, FPOs, and
              agri-entrepreneurs in accessing the AIF subsidy by providing
              end-to-end support in project planning, infrastructure setup, and
              financial guidance. With expertise in modern agri-business
              solutions, <strong>Kryzen Biotech</strong> ensures that
              beneficiaries maximize the advantages of interest subvention and
              credit guarantee schemes, while developing sustainable and
              efficient agricultural projects.
            </p>
            <ol className="fs-2 lh-lg ">
              <li className="">
                Eligibility: Farmers, FPOs, PACS, Cooperatives, Agri-startups,
                SHGs, Joint Liability Groups, and State Agencies.
              </li>
              <li>
                Purpose: Support for post-harvest management infrastructure and
                community farming assets.
              </li>
              <li>
                Financial Support: Interest subvention of 3% per annum up to a
                loan of ₹2 crore for 7 years.
              </li>
              <li>
                Credit Guarantee: Coverage available for loans up to ₹2 crore
                under CGTMSE scheme.
              </li>
              <li>
                Implementation: Projects must be completed within the approved
                timeline.
              </li>
              <li>
                Restrictions: Not applicable for personal consumption-based
                infrastructure.
              </li>
            </ol>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="row mt-7">
          <div className="col-12 col-md-8">
            <h2 className="fw-bold mb-3 text-uppercase fs-1">Benefits</h2>
            <hr />
            <p className="mt-4 fs-2 lh-lg">
              These benefits collectively strengthen the agricultural ecosystem
              by lowering financial burdens, promoting modern business
              practices, and creating new job opportunities in rural areas. By
              reducing post-harvest losses and improving value realization,
              farmers gain higher returns while the overall agri-supply chain
              becomes more efficient. Organizations like
              <strong> Kryzen Biotech</strong> play a crucial role in helping
              farmers and agri-entrepreneurs maximize these advantages through
              expert guidance and sustainable agri-infrastructure solutions.
            </p>
            <ol className="fs-2 lh-lg">
              <li>Reduces cost of credit through interest subvention.</li>
              <li>Encourages private investment in agri-infrastructure.</li>
              <li>
                Promotes modern agri-business models and entrepreneurship.
              </li>
              <li>
                Helps reduce post-harvest losses and improves value realization
                for farmers.
              </li>
              <li>
                Enhances rural employment opportunities and boosts agri-supply
                chain efficiency.
              </li>
            </ol>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex justify-content-center align-items-center">
            <img
              className="card"
              style={{ height: "500px", width: "350px" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844954/benifits_v6xubk.jpg"
              alt="benefits img"
            />
          </div>
        </div>
        {/* <hr></hr> */}
        <hr></hr>
        <div className="row mt-7">
          {/* Image Section */}
          <div className="col-12 col-md-5 mt-4 mt-md-0 d-flex justify-content-center align-items-center mb-4 mb-md-0">
            <img
              className="card img-fluid"
              style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1756358719/shark_tank_uvzuuq.jpg"
              alt="Shark Tank"
            />
          </div>

          {/* Text Section */}
          <div className="col-12 col-md-6 ps-md-2 ms-md-5  text-md-start">
            <h1 className="fw-bold text-uppercase mb-3 fs-1 mt-3 mt-md-0">
              We build best protected farming technology for the world!
            </h1>
            <hr className="mx-auto mx-md-0" />
            <p className="mt-4 fs-2 lh-lg">
              Build a commercially profitable farm anywhere and earn up to
              ₹1,25,000 per month from just 5000 sqft.
            </p>
            <p className="mt-4 fs-2 lh-lg">
              We are top turnkey commercial hydroponics farm project development
              company. We set up hydroponic farms that are low in capex and high
              in returns on investment. With fastest ROI mechanism, We develop
              farm that generates good returns in lowest possible time.
            </p>
          </div>
        </div>

        <div className="row mt-5">
          <h3 className="fs-1 pb-3 text-uppercase">Conclusion</h3>
          <hr></hr>
          <p className="fs-2">
            {" "}
            In conclusion, the <strong>AIF Hydroponic Subsidy</strong> is a
            golden opportunity for farmers and agri-entrepreneurs in {state}.
            Whether you are based in {city} or agricultural belts like Nashik,
            Pune, and Nagpur, the AIF scheme offers{" "}
            <strong>
              {" "}
              affordable financing, interest subvention, and credit support{" "}
            </strong>{" "}
            for building future-ready farming infrastructure.{" "}
          </p>
        </div>
        <div className="row mt-7">
          <div className="row">
            <h2 className="fw-bold text-uppercase mb-3 fs-1">
              Explore AIF Subsidy in Other Cities of {state}
            </h2>
            <hr />

            {district.slice(0, 15).map((city, index) => (
              <div key={index} className="col-12 col-md-4 col-lg-4">
                <ul className="fs-3 lh-lg">
                  <li>
                    <a
                      href={`/aif-government-subsidy/${state}/${city.toLowerCase()}`}
                      className="text-decoration-none text-success"
                    >
                      AIF Subsidy in {city}, {state}
                    </a>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>

        <hr></hr>
        <div className="row">
          <div className="col-12">
            <img
              className="w-100"
              // style={{height:"380px"}}
              src="https://res.cloudinary.com/bsgfcooa/image/upload/v1755844969/footer_jclvvn.jpg"
              alt="footer img"
            ></img>
          </div>
        </div>
      </div>

      <FooterwithoutLogin />
    </div>
  );
};

export default AIFSubsidy;
